import { merge, pick } from 'ramda';
import React from 'react';
import classnames from 'classnames';
import { node, bool, func } from 'prop-types';
import Cell, { TD } from '../cell';
import { Checkbox } from '../../form';
import tableShape from '../tableShape';

const sizeProps = ['minWidth', 'width', 'flex'];

const Row = ({
  className,
  selectable,
  selected,
  checked,
  disabled,
  onSelect,
  onClick,
  children,
  table,
  ...props
}) => {
  const checkboxCell = (
    <Cell className="mdl-data-table__cell--checkbox">
      <Checkbox disabled={disabled} checked={checked} onChange={onSelect} />
    </Cell>
  );

  const cells = React.Children.map(children, (cell, index) => {
    const column = (cell && table.getColumn(cell.props.columnId || index)) || {};
    return cell && React.cloneElement(cell, {
      hidden: column.hidden,
      flex: column.flex,
      alignRight: column.alignRight,
      style: merge(pick(sizeProps, column.style || {}), cell.props.style),
      className: classnames(
        column.className,
        cell.props.className,
      ),
      tag: TD,
    });
  });

  return (
    <tr
      className={classnames(
        'mdc-data-table-row',
        className,
        { 'is-selected': selected },
        { 'is-disabled': disabled },
      )}
      onClick={onClick}
      {...props}
    >
      {selectable && checkboxCell}
      {cells}
    </tr>
  );
};

Row.propTypes = {
  children: node.isRequired,
  onClick: func,
  selectable: bool,
  selected: bool,
  checked: bool,
  onSelect: func,
  table: tableShape,
};

Row.defaultProps = {
  selectable: false,
  selected: false,
  checked: false,
  onClick: undefined,
  onSelect: undefined,
  table: undefined,
};

export default Row;
